import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { finalize, Subject, takeUntil } from 'rxjs';
import { IRecommendedChallenge } from 'src/app/core/domain/recommendation.model';
import { RecommendedService } from 'src/app/core/service/recommended.service';
import { recommendationClosingChip, recommendationReasonLine } from 'src/app/shared/utils/recommendation-reasons';

/**
 * SAN-1481 (EX-07) — "Challenges to apply to" list inside the dashboard-v2
 * "Recommended for you" card. Rendered only when notification_centre_enabled
 * and business_challenges are on (the parent decides). If the backend route
 * is unavailable (older backend, or a flag mismatch -> 403/404) it emits
 * `unavailable` so the parent can drop the tab instead of showing an error.
 */
@Component({
  selector: 'app-recommended-challenges',
  templateUrl: './recommended-challenges.component.html',
  styleUrls: ['./recommended-challenges.component.scss'],
})
export class RecommendedChallengesComponent implements OnInit, OnDestroy {
  @Output() unavailable = new EventEmitter<void>();

  loading = false;
  loaded = false;
  challenges: Array<IRecommendedChallenge & { reasonLine: string; closingChip: string }> = [];

  private destroyed$: Subject<void> = new Subject();

  constructor(private recommendedService: RecommendedService) { }

  ngOnInit(): void {
    this.getChallenges();
  }

  getChallenges() {
    this.loading = true;
    this.recommendedService.getRecommendedChallenges()
      .pipe(
        finalize(() => this.loading = false),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (res) => {
          this.challenges = (res || [])
            .filter((challenge) => challenge?.uuid)
            .map((challenge) => ({
              ...challenge,
              reasonLine: recommendationReasonLine(challenge.matchReasons),
              closingChip: recommendationClosingChip(challenge.matchReasons),
            }));
          this.loaded = true;
        },
        error: () => {
          this.challenges = [];
          this.unavailable.emit();
        },
      });
  }

  trackByUuid(_index: number, challenge: IRecommendedChallenge) {
    return challenge.uuid;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
